import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import HC_more from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exportData from 'highcharts/modules/export-data';
import HC_accessibility from 'highcharts/modules/accessibility';
import * as Highcharts from 'highcharts';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Chart } from 'chart.js';
import {
  getCargoOptions,
  getRecordsOptions,
  getShipNameOptions,
  getTanksOptions,
} from '../../helpers/dropdown-options';
import { RequestFormService } from '../../service/requestForm/request-form.service';

HC_more(Highcharts);
HC_exporting(Highcharts);
HC_exportData(Highcharts);
HC_accessibility(Highcharts);
interface dummyData {
  DATE: number;
  AVG_CARGO: number | null;
  AIR_TEMP: number | null;
  Sea_Water_TEMP: number | null;
}

interface dummyDataSecond {
  DATE: number;
  CARGO_TEMP: number | null;
  //VOY_RANGE_min: number;
  VOY_RANGE_max: number;
  // DISCH_RANGE_min: number;
  DISCH_RANGE_max: number;
  Melt_PT: number;
  LOAD: number;
}
interface TransformedCargoData {
  [key: string]: CargoEntry;
}
interface CargoEntry {
  Cargo: string;
  qty: number;
  load_port: string;
  disch_port: string;
  load_temp: number;
  melt_pt: number;
  voyage_min: number;
  voyage_max: number;
  discharge_min: number;
  discharge_max: number;
  master_dates: number[];
  Avg_Temp: (number | null)[];
}
interface dataSecond {
  air_temp: number | null;
  sea_water_temp: number | null;
  forcast_temp: number | null;
}
interface TransformedForcastoData {
  [key: string]: dataSecond;
}
@Component({
  selector: 'app-gauge-chart',
  templateUrl: './gauge-chart.component.html',
  styleUrls: ['./gauge-chart.component.scss'],
})
export class GaugeChartComponent {
  @Input() gaugeData: any;

  temperatureData = [
    { label: 'Average Cargo Temp:', value: '', color: '#0099a9' },
    { label: 'Pour Point Temp:', value: '', color: 'red' },
    { label: 'Load Temperature:', value: '', color: 'orange' },
    { label: 'Voyage RangeTemp:', value: ' ', color: 'green' },
    { label: 'Discharge Range Temp:', value: '', color: '#ff76ff' },
    // Add more temperature sets here if needed
  ];
  temperatureDataSecond = [
    { label: 'Average Cargo Temp:', value: '',color: '#0099a9'  },
    { label: 'Pour Point Temp:', value: '' ,color: 'red' },
    { label: 'Load Temperature:', value: '',color: 'orange'  },
    { label: 'Voyage RangeTemp:', value:' '  ,color: 'green' },
    { label: 'Discharge Range Temp:', value: '' ,color: '#ff76ff' },

  ];
  dashboardForm!: FormGroup;
  chart!: Chart;
  loadedTemp: any;
  transformedData: TransformedCargoData = {};
  transformedApiData: any;
  apiData: any;
  loadPort: any;
  cargo: any;
  tankDetailsArray: any;
  dischargePort: any;
  parsedDataTwo: any;
  secondchart!: Chart;
  shipnameoptions: string[];
  cargooptions: string[];
  tankoptions: string[];
  mergeGraph = [];
  recordsoptions: string[];
  firstDate: any;
  secondDate: any;
  constructor(
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
  ) {
    this.dashboardForm = this.fb.group({
      graphForm: this.fb.group({
        fromDate: [''],
        toDate: [''],
      }),
      cosp: [''],
      eosp: [''],
      shipname: [''],
      cargo: [''],
      tanks: [''],
      records: [''],
    });
    this.shipnameoptions = getShipNameOptions();
    this.cargooptions = getCargoOptions();
    this.tankoptions = getTanksOptions();
    this.recordsoptions = getRecordsOptions();
  }
  ngOnInit(): void {
    this.setTempValue();
    this.setTempValuetwo()
  }

  setTempValue() {
    let data = this.gaugeData;

    console.log(data, 'data');
    let avgVoyMinMax = `(${data.voyMin} - ${data.voyMax}°C)  `;
    let loadavg = `(${data.loadTemp}°C)`;
    let disAvgMinMax = `(${data.dischMin} - ${data.dischMax}°C)  `;
    let showCargo = `(${data.lastAvgTemp.value.toFixed(2)}°C)`;
  
    let pourTemp = `(${data.meltPt}°C)`;
    this.firstDate = data.lastAvgTemp.date;
    this.secondDate = data.lastForcastTemp.date;
    let graphData = this.temperatureData.map((data: any) => {
      if (data.label === 'Voyage RangeTemp:') {
        data.value = avgVoyMinMax;
      }
      if (data.label === 'Discharge Range Temp:') {
        data.value = disAvgMinMax;
      }
      if (data.label === 'Load Temperature:') {
        data.value = loadavg;
      }
      if (data.label === 'Average Cargo Temp:') {
        data.value = showCargo;
      }
     
      if (data.label === 'Pour Point Temp:') {
        data.value = pourTemp;
      }
      return data;
    });
    this.createChartOne(data);
    this.createChartTwo(data);
  }

  setTempValuetwo() {
    let data = this.gaugeData;

    console.log(data, 'data');
    let avgVoyMinMax = `(${data.voyMin} - ${data.voyMax}°C)  `;
    let loadavg = `(${data.loadTemp}°C)`;
    let disAvgMinMax = `(${data.dischMin} - ${data.dischMax}°C)  `;
   
    let showCargo = `(${data.lastForcastTemp.value.toFixed(2)}°C)`;
    let pourTemp = `(${data.meltPt}°C)`;
    this.firstDate = data.lastAvgTemp.date;
    this.secondDate = data.lastForcastTemp.date;
    let graphData = this.temperatureDataSecond.map((data: any) => {
      if (data.label === 'Voyage RangeTemp:') {
        data.value = avgVoyMinMax;
      }
      if (data.label === 'Discharge Range Temp:') {
        data.value = disAvgMinMax;
      }
      if (data.label === 'Load Temperature:') {
        data.value = loadavg;
      }
      if (data.label === 'Average Cargo Temp:') {
        data.value = showCargo;
      }
      if (data.label === 'Pour Point Temp:') {
        data.value = pourTemp;
      }
      return data;
    });
    this.createChartOne(data);
    this.createChartTwo(data);
}

  createChartOne(data: any) {
    Highcharts.chart('gaugeOne', {
      chart: {
        type: 'gauge',
        plotBackgroundColor: '#fafafa',
        plotBackgroundImage: '#fafafa',
        plotBorderWidth: '',
        plotShadow: '',
        height: '50%',
      },
      title: {
        text: '',
      },
      pane: {
        startAngle: -90,
        endAngle: 90,
        background: null,
        center: ['50%', '80%'],
        size: '90%',
      },
      yAxis: {
        min: 0,
        max: 100,
        tickInterval: 10,
        minorTickInterval: 'auto',
        minorTickWidth: 1,
        minorTickLength: 10,
        minorTickPosition: 'inside',
        minorTickColor: '#666',
        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: '#FFFFFF',
        tickLength: 20,
        tickWidth: 2,
        labels: {
          distance: 20,
          style: {
            fontSize: '12px',
          },
          formatter: function (
            this: Highcharts.AxisLabelsFormatterContextObject
          ): string {
            return this.value + '°C';
          },
        },
        lineWidth: 0,
        plotBands: [
          {
            from: -50,
            to: 100,
            color: '', // red
            thickness: 20,
          },
          {
            from: data.meltPt,
            to: data.meltPt + 0.9,
            color: 'red',
            thickness: 20, // Increased thickness for better visibility
        },
          {
            from: data.voyMin,
            to: data.voyMax,
            color: 'green',
            thickness: 10,
          },
          {
            from: data.dischMin,
            to: data.dischMax,
            color: '#ff76ff', // red
            thickness: 20,
          },
        ],
      },
      series: [
        {
          name: 'Average Cargo Temp',
          data: [data.lastAvgTemp.value],
          dial: {
            backgroundColor: '#0099a9',
            baseWidth: 5,
            topWidth: 2,
            radius: '100%',
          },
          dataLabels: {
            enabled: false,
          },
          pivot: {
            backgroundColor: '#0099a9',
            radius: 1,
          },
        },
        {
          name: 'Load Temperature',
          data: [data.loadTemp],
          dial: {
            backgroundColor: 'orange',
            baseWidth: 5,
            topWidth: 2,
            radius: '100%',
          },
          dataLabels: {
            enabled: false,
          },
          pivot: {
            backgroundColor: 'orange',
            radius: 1,
          },
        },
      ],
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderColor: '#ccc',
        borderRadius: 5,
        borderWidth: 1,
        style: {
          color: '#333',
          fontSize: '14px',
        },
        formatter: function (
          this: Highcharts.TooltipFormatterContextObject
        ): string {
          return (
            '<b>' + this.series.name + '</b><br>' + 'Value: ' + this.y + '°C'
          );
        },
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    } as unknown as Highcharts.Options);
  }
  createChartTwo(data: any) {
    Highcharts.chart('gaugeTwo', {
      chart: {
        type: 'gauge',
        plotBackgroundColor: '#fafafa',
        plotBackgroundImage: '#fafafa',
        plotBorderWidth: 0,
        plotShadow: false,
        height: '50%',
      },
      title: {
        text: '',
      },
      pane: {
        startAngle: -90,
        endAngle: 90,
        background: [], // Changed from null to an empty array
        center: ['50%', '80%'],
        size: '90%',
      },
      yAxis: {
        min: 0,
        max: 100,
        tickInterval: 10,
        minorTickInterval: 'auto',
        minorTickWidth: 1,
        minorTickLength: 10,
        minorTickPosition: 'inside',
        minorTickColor: '#666',
        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: '#FFFFFF',
        tickLength: 20,
        tickWidth: 2,
        labels: {
          distance: 20,
          style: {
            fontSize: '12px',
          },
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject): string {
            return this.value + '°C';
          },
        },
        lineWidth: 0,
        plotBands: [
          {
            from: 0,
            to: 100,
            color: '#EEE', // Placeholder color for the full range
            thickness: 20,
          },
          {
            from: data.meltPt,
            to: data.meltPt + 0.9,
            color: 'red',
            thickness: 20, // Increased thickness for better visibility
          },
          {
            from: data.voyMin,
            to: data.voyMax,
            color: 'green',
            thickness: 10,
          },
          {
            from: data.dischMin,
            to: data.dischMax,
            color: '#ff76ff', // Placeholder color
            thickness: 20,
          },
        ],
      },
      series: [
        {
          type: 'gauge',
          name: 'Average Cargo Temp',
          data: [data.lastForcastTemp.value],
          dial: {
            backgroundColor: '#0099a9',
            baseWidth: 5,
            topWidth: 2,
            radius: '100%',
          },
          dataLabels: {
            enabled: false,
          },
          pivot: {
            backgroundColor: '#0099a9',
            radius: 1,
          },
        },
        {
          type: 'gauge',
          name: 'Load Temperature',
          data: [data.loadTemp],
          dial: {
            backgroundColor: 'orange',
            baseWidth: 5,
            topWidth: 2,
            radius: '100%',
          },
          dataLabels: {
            enabled: false,
          },
          pivot: {
            backgroundColor: 'orange',
            radius: 1,
          },
        },
      ],
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderColor: '#ccc',
        borderRadius: 5,
        borderWidth: 1,
        style: {
          color: '#333',
          fontSize: '14px',
        },
        formatter: function (this: Highcharts.TooltipFormatterContextObject): string {
          const value = this.y != null ? this.y.toFixed(2) : 'N/A';
          return (
            '<b>' + this.series.name + '</b><br>' + 'Value: ' + value + '°C'
          );
        },
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    } as Highcharts.Options);
  }
  
  isDarkMode(): boolean {
    return this.requestFormService.isDarkMode();
  }



}
